module.exports = __webpack_public_path__ + "img/back-arrow.ef4e9045.svg";